
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PriceQuery } from '@/mixins/price_query';
import { gradeItem } from '@/interface/purchase';
@Component({})
export default class extends Vue {
  @Prop() model!: any; // 选中的档位
  @Prop({ default: true }) showRadio!: boolean; // 选中的档位
  @Prop({ default: 0 }) client!: number;
  priceQuery = new PriceQuery();

  stateModel = [
    {
      id: 1,
      value: 'coin',
      lable: '云币',
    },
    {
      id: 2,
      value: 'card',
      lable: '周期卡',
    },
  ];

  // options: Array<gradeItem> = [{ grade: -1, name: '请选择' }];
  get options(): Array<gradeItem> {
    return this.model.grade_type === 1 ? this.coinOptions : this.cardOptions;
  }

  coinOptions: Array<gradeItem> = [];
  cardOptions: Array<gradeItem> = [];

  cardTypeChange(id: number) {
    const item: any = this.stateModel.find(x => x.id === id);
    this.coinOptions = [];
    this.priceQuery.getMarketingGrades(item.value, this.client).then(list => {
      if (id === 1) {
        this.coinOptions = list;
        this.coinOptions.unshift({ grade: -1, name: '请选择' });
      } else {
        this.cardOptions = list;
        this.cardOptions.unshift({ grade: -1, name: '请选择' });
      }
    });
    this.$emit('grandTypeChange');
  }
  created() {
    const _this = this;

    _this.stateModel.forEach(item => {
      _this.cardTypeChange(item.id);
    });
  }
}
